import { module } from 'angular';

import { CustomerCardsDeprecatedService, default as customerCardsService } from '../customer-cards-deprecated.service';
import { CustomerCardOnly, default as customerCardOnly } from './customer-card-only.component';

export default module('contact.commons.customer.card.only', [])
  .component(customerCardOnly, new CustomerCardOnly())
  .service(customerCardsService, CustomerCardsDeprecatedService).name;
